import React from 'react';
import { Card } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';
import styles from './index.module.css';

const EmptyStateGraph: React.FC<{ noAccountSelected?: boolean }> = ({
  noAccountSelected,
}) => {
  return (
    <Card className={`emptyStateCard ${styles.emptyStateCard}`}>
      <BarChartOutlined className={styles.icon} />
      <h3 className={styles.title}>Oops! No Insights Yet</h3>
      <p className={styles.description}>
        {noAccountSelected
          ? 'Please select at least one account'
          : 'Looks like there is no data for the selected period. Try selecting a different time range/ account to see your insights!'}
      </p>
    </Card>
  );
};

export default EmptyStateGraph;
